<button type="button" class="task-notification"
        [class.task-notification--active]="taskNotification.hasRunning"
        [title]="label" [attr.aria-label]="label"
        (click)="openTaskLogs()">
  <i class="fa-regular fa-bell task-notification__icon" aria-hidden="true"></i>
  @if (taskNotification.hasUnseenDone) {
  <span class="task-notification__badge">
    <i class="fa-solid fa-asterisk" aria-hidden="true"></i>
    <span class="visually-hidden">A task finished</span>
  </span>
  }
</button>
